
// import React from 'react';

// const Menu = () => {
//   const hotline = "5864416350";

//   return (
//     <section id="menu" className="py-24 px-6 max-w-7xl mx-auto scroll-mt-24 bg-[#0a0a0a]">
//       {/* INJECTED STYLES */}
//       <style dangerouslySetInnerHTML={{ __html: `
//         :root { --gold: #d4af37; }
//         @keyframes wheel-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        
//         .action-tire {
//           position: relative; width: 200px; height: 200px; background: #080808;
//           border: 18px solid #151515; border-radius: 50%; display: flex;
//           flex-direction: column; align-items: center; justify-content: center;
//           transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1); box-shadow: 0 20px 40px rgba(0,0,0,0.6);
//           overflow: hidden; cursor: pointer; text-decoration: none;
//         }
//         .action-tire:hover { transform: scale(1.1) rotate(-8deg); border-color: #222; }
//         .tire-tread { position: absolute; inset: -5px; border: 4px dashed #111; border-radius: 50%; opacity: 0.5; }
//         .action-tire:hover .tire-tread { animation: wheel-spin 2s linear infinite; border-color: var(--gold); }
        
//         .menu-card { 
//           background: #111; 
//           border: 1px solid #222; 
//           padding: 2rem; 
//           border-radius: 1.5rem; 
//           transition: all 0.3s ease; 
//           display: flex; 
//           flex-direction: column; 
//           height: 100%; 
//         }
//         .menu-card:hover { 
//           border-color: var(--gold); 
//           transform: translateY(-8px); 
//           box-shadow: 0 15px 30px rgba(0,0,0,0.4); 
//         }
//       `}} />

//       <div className="text-center mb-20">
//         <h2 className="font-['Bebas_Neue'] text-7xl italic tracking-tighter mb-4 uppercase text-white">Pitstop Menu</h2>
//         <p className="text-gray-500 uppercase tracking-[0.3em] text-sm font-bold">Crafted for the heavy foot</p>

//         <div className="flex flex-wrap justify-center items-center gap-10 mt-16">
//            <ActionTire label="Hotline" title="CALL TO ORDER" sub="(586) 441-6350" link={`tel:${hotline}`} />
//            <ActionTire label="Delivery" title="DOORDASH" sub="Express Track" link="#" color="#FF3008" />
//            <ActionTire label="100%" title="Zabiha" sub="Halal" link="#" />
//         </div>
//       </div>

//       {/* BURGERS */}
//       <CategoryHeader title="BURGERS" sub="Our signature smashed beef on toasted brioche." accent="border-yellow-500">
//          <div className="bg-yellow-500 text-black px-4 py-2 rounded font-black text-sm italic animate-pulse">
//            MAKE IT A COMBO WITH FRIES FOR +$3.00
//          </div>
//       </CategoryHeader>
      
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-24">
//         <MenuCard title="OG PITSTOP SMASH" price="11.99" desc="Two smashed patties, 2 slices of cheese, and signature DRIFT sauce." badge="#1 MOST LIKED" rating="87% (8)" />
//         <MenuCard title="TRIPLE THREAT SMASH" price="15.99" desc="Three patties, three slices of cheese, and DRIFT sauce." />
//         <MenuCard title="FULL THROTTLE SMASH" price="17.99" desc="Four patties, four slices of cheese, and DRIFT sauce." />
//         <MenuCard title="FIRST GEAR" price="9.99" desc="1 patty, 1 slice of cheese, and DRIFT sauce." />
//         <MenuCard title="NAGA TURBO SMASH" price="11.99" desc="Smash burger with housemade Naga BBQ sauce." badge="🔥 SPICY" isSpicy />
//         <MenuCard title="GRILLED CHEESE" price="6.99" desc="Cheese, DRIFT sauce, and grilled onions." />
//       </div>

//       {/* SIDES */}
//       <CategoryHeader title="SIDES" sub="Fuel up with our premium sides." accent="border-gray-500" />
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-24">
//         <MenuCard title="PITSTOP FRIES" price="10.99" desc="Cheese, grilled onions, and signature DRIFT sauce." />
//         <MenuCard title="FULLY LOADED FRIES" price="13.99" desc="PitStop fries with your choice of protein (Beef or Chicken)." />
//         <MenuCard title="REGULAR FRIES" price="7.99" desc="Crispy golden fries, salted to perfection." />
//         <MenuCard title="TATER TOTS" price="8.99" desc="Crispy golden tots, perfect for dipping." />
//         <MenuCard title="ONION RINGS" price="8.99" desc="Crispy golden-fried, perfectly seasoned crunch." />
//       </div>

//       {/* RICE PLATTERS */}
//       <CategoryHeader title="RICE PLATTERS" sub="Seasoned rice served with white and hot sauce." accent="border-blue-500" />
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-24">
//         <MenuCard title="MIXED" price="14.99" desc="Seasoned chicken and lamb over rice with lettuce, tomatoes, and white sauce." />
//         <MenuCard title="CHICKEN" price="13.99" desc="Grilled chicken with mixed veggies on seasoned rice and topped with homemade white sauce." />
//         <MenuCard title="LAMB GYRO" price="13.99" desc="Grilled lamb over seasoned rice with lettuce, tomatoes, onions, white and hot sauce." />
//       </div>

//       {/* --- LETS CONNECT SECTION --- */}
//       <div className="mt-32 border-t border-white/5 pt-24 text-center">
//         <h2 className="font-['Bebas_Neue'] text-6xl italic tracking-tighter mb-4 text-white uppercase">Let's Connect</h2>
//         <p className="text-gray-500 uppercase tracking-[0.3em] text-sm font-bold mb-16">Follow the flavor on social track</p>
        
//         <div className="flex flex-wrap justify-center items-center gap-12">
//            <ActionTire label="Instagram" title="INSTAGRAM" sub="@PrimeEats" link="https://instagram.com" />
//            <ActionTire label="TikTok" title="TIKTOK" sub="@PrimeEats" link="https://tiktok.com" color="#00f2ea" />
//            <ActionTire label="Facebook" title="FACEBOOK" sub="Prime Eats" link="https://facebook.com" color="#1877f2" />
//         </div>
//       </div>
//     </section>
//   );
// };

// /* --- HELPER COMPONENTS --- */
// const ActionTire = ({ label, title, sub, link, color = "#d4af37" }) => (
//   <a href={link} target="_blank" rel="noopener noreferrer" className="action-tire group">
//     <div className="tire-tread"></div>
//     <div className="relative z-10 text-center font-['Bebas_Neue'] px-4">
//       <div className="text-[9px] text-gray-500 tracking-widest uppercase mb-1">{label}</div>
//       <div className="text-2xl leading-tight transition-colors group-hover:text-white" style={{ color }}>{title}</div>
//       <div className="mt-2 text-[9px] text-gray-600 font-bold uppercase group-hover:text-gray-400 transition-colors">{sub}</div>
//     </div>
//   </a>
// );

// const CategoryHeader = ({ title, sub, accent, children }) => (
//   <div className={`mb-12 bg-gradient-to-r from-white/5 to-transparent border-l-4 ${accent} p-8 rounded-r-lg flex flex-col md:flex-row justify-between items-center gap-6`}>
//     <div>
//       <h3 className="font-['Bebas_Neue'] text-5xl text-white">{title}</h3>
//       <p className="text-gray-400 text-sm">{sub}</p>
//     </div>
//     {children}
//   </div>
// );

// const MenuCard = ({ title, price, desc, badge, rating, isSpicy }) => (
//   <div className="menu-card group">
//     <div className="mb-4">
//       {badge && (
//         <div className={`inline-block px-3 py-1 rounded-sm text-[9px] font-black mb-4 ${isSpicy ? 'bg-red-600 text-white' : 'bg-[#d4af37] text-black'}`}>
//           {badge}
//         </div>
//       )}
//       <div className="flex justify-between items-start">
//         <h4 className="text-2xl font-bold italic group-hover:text-[#d4af37] transition-colors pr-2 text-white">{title}</h4>
//         <span className="text-xl font-black text-[#d4af37]">${price}</span>
//       </div>
//     </div>
//     <p className="text-gray-500 text-sm leading-relaxed mb-6">{desc}</p>
//     {rating && (
//       <div className="mt-auto pt-4 border-t border-white/5 text-[9px] text-gray-600 font-bold tracking-widest uppercase">
//         Pit-Rating: {rating}
//       </div>
//     )}
//   </div>
// );

// export default Menu;

import React from 'react';

const Menu = () => {
  const hotline = "5864416350";

  return (
    <section id="menu" className="py-24 px-6 max-w-7xl mx-auto scroll-mt-24 bg-[#0a0a0a]">
      {/* INJECTED STYLES */}
      <style dangerouslySetInnerHTML={{ __html: `
        :root { --gold: #d4af37; }
        @keyframes wheel-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        
        .action-tire {
          position: relative; width: 200px; height: 200px; background: #080808;
          border: 18px solid #151515; border-radius: 50%; display: flex;
          flex-direction: column; align-items: center; justify-content: center;
          transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1); box-shadow: 0 20px 40px rgba(0,0,0,0.6);
          overflow: hidden; cursor: pointer; text-decoration: none;
        }
        .action-tire:hover { transform: scale(1.1) rotate(-8deg); border-color: #222; }
        .tire-tread { position: absolute; inset: -5px; border: 4px dashed #111; border-radius: 50%; opacity: 0.5; }
        .action-tire:hover .tire-tread { animation: wheel-spin 2s linear infinite; border-color: var(--gold); }
        
        .menu-card { 
          background: #111; 
          border: 1px solid #222; 
          padding: 2rem; 
          border-radius: 1.5rem; 
          transition: all 0.3s ease; 
          display: flex; 
          flex-direction: column; 
          height: 100%; 
        }
        .menu-card:hover { 
          border-color: var(--gold); 
          transform: translateY(-8px); 
          box-shadow: 0 15px 30px rgba(0,0,0,0.4); 
        }
      `}} />

<div className="text-center mb-20">
  <h2 className="font-['Bebas_Neue'] text-7xl italic tracking-tighter mb-4 uppercase text-white">
    Prime Eats Menu
  </h2>
  <p className="text-gray-400 uppercase tracking-[0.35em] text-sm font-bold">
    Fresh • Halal • Made to Order
  </p>

        <div className="flex flex-wrap justify-center items-center gap-10 mt-16">
           <ActionTire label="Hotline" title="CALL TO ORDER" sub="(734) 286-4221" link={`tel:${hotline}`} />
           <ActionTire label="Delivery" title="DOORDASH" sub="Express Track" link="https://www.doordash.com/store/prime-eats-westland-37964537/87505159/?utm_campaign=gpa" color="#FF3008" />
           <ActionTire label="100%" title="Zabiha" sub="Halal" link="#" />
        </div>
      </div>

{/* SMASH BURGERS */}
<CategoryHeader 
  title="SMASH BURGERS" 
  sub="Fresh smashed burgers loaded with flavor." 
  accent="border-yellow-500"
>
  <div className="bg-yellow-500 text-black px-4 py-2 rounded font-black text-sm italic animate-pulse">
    MAKE IT A COMBO WITH FRIES FOR +$3.99
  </div>
</CategoryHeader>

<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-24">
        
        <MenuCard 
          title="BBQ BACON SMASH BURGER" 
          price="10.99" 
          desc="Halal turkey bacon, grilled onions, mayo & BBQ sauce. Available on brioche and pretzel hamburger buns." 
          badge="🔥 POPULAR"
        />

        <MenuCard 
          title="PRIME SMASH BURGER" 
          price="10.99" 
          desc="Lettuce, tomatoes, pickles, american cheese, house sauce." 
          badge="🔥 POPULAR"
        />
        <MenuCard 
          title="SOUTHWEST SMASH BURGER" 
          price="10.99" 
          desc="Grilled jalapeños, pepper jack cheese, spicy chipotle mayo." 
        />
      </div>

      {/* WRAPS */}
      <CategoryHeader title="WRAPS" sub="Fresh wraps packed with bold flavor." accent="border-green-500" />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-24">
        <MenuCard 
          title="CHICKEN CAESAR WRAP" 
          price="9.99" 
          desc="Lettuce, tomatoes, caesar sauce, croutons." 
        />
        <MenuCard 
          title="GRILLED CHICKEN WRAP" 
          price="9.99" 
          desc="Lettuce, pickles, tomatoes, swiss american blend cheese, chipotle mayo." 
          badge="🔥 POPULAR"
        />
        <MenuCard 
          title="STEAK & CHEESE WRAP" 
          price="9.99" 
          desc="Lettuce, pickles, swiss cheese, chipotle mayo." 
          badge="🔥 POPULAR"
        />
      </div>

      {/* SIDES */}
      <CategoryHeader title="SIDES" sub="Fuel up with our premium sides." accent="border-gray-500" />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-24">
        <MenuCard 
          title="MOZZARELLA STICKS" 
          price="4.99" 
          desc="Crispy fried cheese sticks served with a zesty marinara sauce, perfect for appetizer or snack." 
        />
        <MenuCard 
  title="REGULAR OR CAJUN FRIES" 
  price="4.99" 
  desc="Crispy golden fries tossed in your choice of regular salt or bold cajun seasoning." 
/>
        <MenuCard 
          title="ONION RINGS" 
          price="4.99" 
          desc="Crispy golden-fried onion rings, perfectly seasoned for a savory crunch." 
        />
      </div>

      {/* LETS CONNECT */}
      <div className="mt-32 border-t border-white/5 pt-24 text-center">
        <h2 className="font-['Bebas_Neue'] text-6xl italic tracking-tighter mb-4 text-white uppercase">Let's Connect</h2>
        <p className="text-gray-500 uppercase tracking-[0.3em] text-sm font-bold mb-16">Follow the flavor on social track</p>
        
        <div className="flex flex-wrap justify-center items-center gap-12">
           <ActionTire label="Instagram" title="INSTAGRAM" sub="@PrimeEats" link="https://www.instagram.com/_primeeats" />
           <ActionTire label="TikTok" title="TIKTOK" sub="@PrimeEats" link="https://www.tiktok.com/@_primeeats" color="#00f2ea" />
           <ActionTire label="Facebook" title="FACEBOOK" sub="Prime Eats" link="https://www.facebook.com/p/Prime-Eats-61584580475488/" color="#1877f2" />
        </div>
      </div>
    </section>
  );
};

/* --- HELPER COMPONENTS --- */
const ActionTire = ({ label, title, sub, link, color = "#d4af37" }) => (
  <a href={link} target="_blank" rel="noopener noreferrer" className="action-tire group">
    <div className="tire-tread"></div>
    <div className="relative z-10 text-center font-['Bebas_Neue'] px-4">
      <div className="text-[9px] text-gray-500 tracking-widest uppercase mb-1">{label}</div>
      <div className="text-2xl leading-tight transition-colors group-hover:text-white" style={{ color }}>{title}</div>
      <div className="mt-2 text-[9px] text-gray-600 font-bold uppercase group-hover:text-gray-400 transition-colors">{sub}</div>
    </div>
  </a>
);

const CategoryHeader = ({ title, sub, accent, children }) => (
  <div className={`mb-12 bg-gradient-to-r from-white/5 to-transparent border-l-4 ${accent} p-8 rounded-r-lg flex flex-col md:flex-row justify-between items-center gap-6`}>
    <div>
      <h3 className="font-['Bebas_Neue'] text-5xl text-white">{title}</h3>
      <p className="text-gray-400 text-sm">{sub}</p>
    </div>
    {children}
  </div>
);

const MenuCard = ({ title, price, desc, badge, rating, isSpicy }) => (
  <div className="menu-card group">
    <div className="mb-4">
      {badge && (
        <div className={`inline-block px-3 py-1 rounded-sm text-[9px] font-black mb-4 ${isSpicy ? 'bg-red-600 text-white' : 'bg-[#d4af37] text-black'}`}>
          {badge}
        </div>
      )}
      <div className="flex justify-between items-start">
        <h4 className="text-2xl font-bold italic group-hover:text-[#d4af37] transition-colors pr-2 text-white">{title}</h4>
        <span className="text-xl font-black text-[#d4af37]">${price}</span>
      </div>
    </div>
    <p className="text-gray-500 text-sm leading-relaxed mb-6">{desc}</p>
    {rating && (
      <div className="mt-auto pt-4 border-t border-white/5 text-[9px] text-gray-600 font-bold tracking-widest uppercase">
        Pit-Rating: {rating}
      </div>
    )}
  </div>
);

export default Menu;